import type { Journal } from "@vlab-corporation/vlab-pilates-service-interface/class";
import type { ID } from "@vlab-corporation/vlab-pilates-service-interface/types";

/**
 * 같은 강사가 같은 회원에게 작성한 "다른 수업의" OT 일지들을 찾는다.
 * (현재 편집 중인 classId는 self이므로 제외)
 *
 * 강사-회원당 OT 일지 1개 불변식을 위한 중복 검사에 사용한다.
 * 호출자는 회원별 일지 목록(getJournalsByMemberId 결과)을 넘긴다.
 */
export function findConflictingOtJournals(
  journals: Journal[],
  instructorId: ID,
  currentClassId: string,
): Journal[] {
  return journals.filter(
    (j) =>
      j.isOt === true &&
      j.instructorId === instructorId &&
      String(j.classId) !== String(currentClassId),
  );
}
